/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';

/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#save
 *
 * @return {Element} Element to render.
 */
export default function save({attributes}) {
	const { src, type, width, height } = attributes;
	
	const videoJsOptions = {
		techOrder: ['youtube'],
		sources: [
			{
				type: 'video/youtube',
				src: src , // Use videoURL from attributes
				muted: false,
			}
		]
	};

	return (
		<p { ...useBlockProps.save() }>
			{ type!='video/youtube' && (
				<video
					id="my-video"
					className="video-js vjs-default-skin"
					controls="true"
					autoplay="false"
					preload="true"
					width={width} 
					height={height}
					data-setup='{ "muted": false }'
					>
					<source src={src} type={type}/>
				</video>
			) }
			{ type=='video/youtube' && (
				<video
					id="my-video"
					className="video-js vjs-default-skin"
					controls="true"
					autoplay="false"
					preload="true"
					width={width}
					height={height}
					data-setup={JSON.stringify(videoJsOptions)}
					>
				</video>
			) }
		</p>
		
	);
}
